import React from "react";
import cx from "classnames";

function BasicButton(props) {
  let { children, baseClassName, className, type, look, active, domRef, ...otherProps } = props;

  let lookName = "";
  let activeClass = "";

  if (look) {
    lookName = baseClassName + "--" + look;
  }

  if (active) {
    activeClass = "active";
  }

  return (
    <button
      ref={domRef}
      type={type}
      className={cx(baseClassName, lookName, className, activeClass)}
      {...otherProps}
    >
      {children}
    </button>
  );
}

const Button = React.forwardRef((props, ref) => <BasicButton domRef={ref} {...props} />);

Button.defaultProps = {
  type: "button",
  baseClassName: "si-c-btn",
};

export default Button;
